import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';

export default function SharedWithMe() {

  const navigate = useNavigate();

  const [documents, setDocuments] = useState([]);

  function OpenDocument(urlkey)
  {
    navigate(`/document/${urlkey}`);
  }

  useEffect(async () => {
    const url = "https://docsserver.onrender.com/sharedwithme/getShared";

    let res = await Axios.get(url);

    if(typeof(res) == 'object')
    {
      setDocuments(res.data.SharedWithMe);
    }
    else
    {
      window.alert("error");
    }

  }, [])

  return (
    <section className='p-3 mt-5'>
        <h1 className='text-3xl font-semibold'><span className='animate-pulse'>📝 </span>Shared With Me</h1>

        <div className='p-5 flex flex-col justify-center items-center md:grid md:grid-cols-4 w-4/5 mx-auto'>
                {documents.length !== 0 ?documents.map((item) => {
                    //console.log(documents);
                    return(
                        <div onClick={() => OpenDocument(item.urlkey)} key={item._id} className="w-fit border-2 border-slate cursor-pointer mt-5 md:ml-5">
                            <div className='bg-white border-b min-h-[180px] max-h-[200px] min-w-[150px] max-w-full flex items-center justify-center overflow-hidden'>
                                <div className='overflow-hidden p-2 blur'>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                                </div>
                            </div>
                            <div className='flex flex-col justify-center align-middle items-start p-3'>
                                <p className='font-semibold text-lg'>{item.name}</p>
                                <div className='flex items-center'>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                                    </svg>
                                    <p className='text-gray-500 text-[0.8em] ml-1'>Created on {item.dateCreated}</p>
                                </div>
                            </div>
                        </div>
                    )
                }): <p className='text-2xl text-center animate-bounce'>🙇‍♂️ No Shared Docx</p>}
            </div>
    </section>
  )
}
